import { MDBAlert, MDBBtn, MDBModalFooter } from "mdb-react-ui-kit";
import { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { updateValidatedPhNumDtls } from "../../../apiclients/streamsapi_bridge";

const EditValidatedPHnum = forwardRef((props, ref) => {
  const [aliasName, setAliasName] = useState(props.alias_name);
  const [errors, setErrors] = useState({});
  const [internalError, setInternalError] = useState(false);
  //const [isloading, setIsloading] = useState(false);
  const { t } = useTranslation();


  async function updateAliasInfo() {
    try {
      let updateInfo = {
        reqid: 74,
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        phone_number: props.phoneNum.toString().replace(/[+ -]/g, ''),
        general: {
          alias_name: aliasName
        }
      }
      setInternalError(false);
      props.setIsloading(true);
      let apiResponse = await updateValidatedPhNumDtls(updateInfo);
      setTimeout(() => { props.setIsloading(false) }, 1000);
      let resdata = await apiResponse.json();
      if (apiResponse.status == 200) {
        props.setSuccessMessage(resdata.message);
        props.onClose();
        // window.location.href = "/phonenumbers";
        props.setrerender(true);
      } else if (apiResponse.status == 400) {
        let errorsJson = resdata.message.errors.reduce((obj, value) => {
          obj[value.param_name] = value.message;
          return obj
        }, {});
        setErrors(errorsJson);

      } else {
        setInternalError(true);
      }

    } catch (error) {
      console.log(`uable to send the request :${error}`);
      setInternalError(true);
    }
  }


  return (<>

    <form>
      <div className="row ">
        <div className="add-numbermain">
          <div className="tel-numbers w-50">
            <strong>{"Phone Number(s)"}</strong>
          </div>
          <div className="form pt-1 w-100">
            {props.phoneNum}
          </div>
        </div>
        <div className="add-numbermain mb-3">
          <div className="tel-numbers">
            <strong>{t("aliasname")}</strong>
          </div>
          <div className="form pt-1">
            <input
              type="text"
              className="w-100"
              value={aliasName}
              onChange={(e) => setAliasName(e.target.value)}
            />
            {errors[`general.alias_name`] && (
              <p className="text-danger">{errors[`general.alias_name`]}</p>
            )}
          </div>
        </div>

        <div style={{ display: "none" }}>
          <button ref={ref} onClick={(e) => { e.preventDefault(); updateAliasInfo() }}>
            {t("Save")}</button>
        </div>

        {/* <MDBModalFooter>
          <MDBBtn onClick={(e) => props.onClose(e)} color="secondary">
            {t("close")}
          </MDBBtn>
          <MDBBtn onClick={(e) => {
            e.preventDefault();
            updateAliasInfo();
          }} color="primary">
            {t("Save")}
          </MDBBtn>
        </MDBModalFooter> */}
      </div>{" "}
    </form>

    {internalError && (<MDBAlert
      open
      className="alert-center"
      color="danger"
      autohide
      position="bottom-right"
      delay={5000}
    >Internal Server Error</MDBAlert>)}

  </>);

});

export default EditValidatedPHnum;